import {BaseComponent} from "../common/base/base.component";
import {InjectionToken} from "@angular/core";

export const WidgetConfig = new InjectionToken<IWidgetConfig>('WidgetConfig');


export interface IWidgetConfig {
  widgetType: string;
  widgetSubType?: string;
  hostClass?: string;
  displayType?: string;
}

export abstract class WidgetRef {}

export abstract class DialogRef<T extends BaseComponent> {
  bsModal: any;
}

export type ChangeListener = (key: string, nv: any, ov?: any) => void;

export const Context = new InjectionToken('Context Provider Reference');

// export const PARENT_REF = new InjectionToken<Parent>('ParentRef');
// @Injectable()
// export abstract class Parent {
//
// }
